import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { AddIcon, Button } from "native-base";

export default function CreateUserButton() {
  const navigate = useNavigate();

  const onCreateObject = useCallback(async () => {
    navigate(`/admin/users/create`);
  }, [navigate]);

  return (
    <Button
      onPress={onCreateObject}
      colorScheme="primary"
      startIcon={<AddIcon />}
      alignSelf="flex-end"
    >
      Benutzer erstellen
    </Button>
  );
}
